import { customHierarchyMockData } from '../fixtures';
import { Observable, of } from 'rxjs';

export class MockCustomHierarchyDropdownServiceHandler {
  public getAccountHierarchy(): Observable<any> {
    return of(customHierarchyMockData.customHierarchyData);
  }
}
